import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {useLocation} from "react-router-dom"

import {StripeOXXOForm} from "@indebted/stripe"
import {Page} from "@indebted/components/Page"

function OXXOForm({
	i18n,
	locale,
	onSubmit,
	publishableKey,
	termsOfDiscountOffer,
	morePaymentMethodsAvailable,
	clientSecret,
}) {
	const location = useLocation()

	return (
		<Page padded>
			<Grid container direction="column" alignItems="stretch" spacing={5} padding={0}>
				<Grid>
					<Typography variant="h6">{i18n.Header}</Typography>
				</Grid>
				<Grid>
					<Typography>{i18n.Title}</Typography>
				</Grid>

				<Grid>
					<StripeOXXOForm
						i18n={i18n}
						locale={locale}
						onSubmit={onSubmit}
						publishableKey={publishableKey}
						morePaymentMethodsAvailable={morePaymentMethodsAvailable}
						paymentMethodSelectionLink={`PaymentMethodSelection/${location.search}`}
						termsOfDiscountOffer={termsOfDiscountOffer}
						clientSecret={clientSecret}
					/>
				</Grid>
			</Grid>
		</Page>
	)
}

export {OXXOForm}
